import { Dispatch, SetStateAction, useEffect } from 'react'
import { ScheduleType } from 'types/schedule'
import { SpecialHolidayType } from 'types/calendar'
import { StockType } from 'types/stock'
import { StoreCalendarType } from 'types/storeCalendar'
import { DayOfWeekType, DaysOfWeek } from 'lib/daysOfWeek'
import { parseToDate } from 'lib/helper'
import { differenceInMinutes } from 'date-fns'
const daysOfWeek = new DaysOfWeek()

const useSetIndividualScheduleDates = (
  schedules: ScheduleType[],
  setIndividualSettingDates: Dispatch<SetStateAction<Date[]>>,
  specialHolidays: SpecialHolidayType[],
  stocks: StockType[],
  storeCalendars: StoreCalendarType[]
) => {
  useEffect(() => {
    const _individualSettingDates: Date[] = []

    for (let i = 0; i < stocks.length; i = (i + 1) | 0) {
      const stock = stocks[i]
      const dayOfWeek: DayOfWeekType = daysOfWeek.getDayOfWeek(parseToDate(stock.date), specialHolidays)

      const mergedDaysOfWeek = schedules.reduce((prev, schedule) => {
        return [...prev, ...schedule.days_of_week]
      }, [] as DayOfWeekType[])

      // 受渡可能日ではない曜日に設定されていれば個別設定とする
      if (!mergedDaysOfWeek.includes(dayOfWeek)) {
        _individualSettingDates.push(parseToDate(stock.date))
        continue
      }

      // 受渡可能日が臨時休業日であれば個別設定とする
      if (
        storeCalendars.some((storeCalendar) => {
          return storeCalendar.status === 'close' && storeCalendar.date === stock.date
        })
      ) {
        _individualSettingDates.push(parseToDate(stock.date))
        continue
      }

      const schedule =
        schedules.find((schedule) => {
          return schedule.days_of_week.includes(dayOfWeek)
        }) ?? schedules[0]
      if (!schedule) continue

      // 事前予約の在庫に設定されている注文の締切日時タイムスタンプを数値に変換
      const hoursToDeadline = differenceInMinutes(parseToDate(stock.date), stock.deadline.toDate()) / 60
      if (
        schedule.note !== stock.note ||
        schedule.hours_to_deadline !== hoursToDeadline ||
        schedule.default_stocks.every((defaultStock) => {
          return (
            // 一致する受渡解禁時刻がない
            defaultStock.pickupable_time !== stock.pickupable_time ||
            // 受渡解禁時刻は一致するがオープン時在庫数が一致しない
            (defaultStock.pickupable_time === stock.pickupable_time && defaultStock.stock !== stock.stock)
          )
        })
      ) {
        _individualSettingDates.push(parseToDate(stock.date))
      }
    }

    setIndividualSettingDates([..._individualSettingDates])
  }, [schedules, stocks, specialHolidays, storeCalendars])
}

export default useSetIndividualScheduleDates
